import { throttle } from "@tt-app/utils/throttle";
import { VUEX_ROOT_ACTION_NAMES } from "@tt-app/constants";

export const appHashCheckerPlugin = (store: any) => {
  const checkHash = throttle(() => {
    store.dispatch(VUEX_ROOT_ACTION_NAMES.CHECK_APP_HASH);
  }, 300000);

  store.subscribeAction(checkHash);
};
